import * as tslib_1 from "tslib";
import { extend, jsS, isUrlAbsolute } from "@pnp/common";
import { SharePointQueryable, SharePointQueryableCollection, SharePointQueryableInstance, defaultPath } from "./sharepointqueryable";
import { SharePointQueryableShareableFolder } from "./sharepointqueryableshareable";
import { Files } from "./files";
import { odataUrlFrom } from "./odata";
import { Item } from "./items";
import { extractWebUrl } from "./utils/extractweburl";
/**
 * Describes a collection of Folder objects
 *
 */
var Folders = /** @class */ (function (_super) {
    tslib_1.__extends(Folders, _super);
    function Folders() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Folders_1 = Folders;
    /**
     * Gets a folder by folder name
     *
     */
    Folders.prototype.getByName = function (name) {
        var f = new Folder(this);
        f.concat("('" + name + "')");
        return f;
    };
    /**
     * Adds a new folder to the current folder (relative) or any folder (absolute)
     *
     * @param url The relative or absolute url where the new folder will be created. Urls starting with a forward slash are absolute.
     * @returns The new Folder and the raw response.
     */
    Folders.prototype.add = function (url) {
        var _this = this;
        return this.clone(Folders_1, "add('" + url + "')").postCore().then(function (data) {
            return {
                data: data,
                folder: _this.getByName(url),
            };
        });
    };
    /**
     * Adds a new folder by path and should be prefered over add
     *
     * @param serverRelativeUrl The server relative url of the new folder to create
     * @param overwrite True to overwrite an existing folder, default false
     */
    Folders.prototype.addUsingPath = function (serverRelativeUrl, overwrite) {
        var _this = this;
        if (overwrite === void 0) { overwrite = false; }
        return this.clone(Folders_1, "addUsingPath(DecodedUrl='" + serverRelativeUrl + "',overwrite=" + overwrite + ")").postCore().then(function (data) {
            return {
                data: data,
                folder: new Folder(extractWebUrl(_this.toUrl()), "_api/web/getFolderByServerRelativePath(decodedUrl='" + serverRelativeUrl + "')"),
            };
        });
    };
    var Folders_1;
    Folders = Folders_1 = tslib_1.__decorate([
        defaultPath("folders")
    ], Folders);
    return Folders;
}(SharePointQueryableCollection));
export { Folders };
/**
 * Describes a single Folder instance
 *
 */
var Folder = /** @class */ (function (_super) {
    tslib_1.__extends(Folder, _super);
    function Folder() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.update = _this._update("SP.Folder", function (data) { return ({ data: data, folder: _this }); });
        return _this;
    }
    Object.defineProperty(Folder.prototype, "contentTypeOrder", {
        /**
         * Specifies the sequence in which content types are displayed.
         *
         */
        get: function () {
            return new SharePointQueryableCollection(this, "contentTypeOrder");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Folder.prototype, "files", {
        /**
         * Gets this folder's files
         *
         */
        get: function () {
            return new Files(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Folder.prototype, "folders", {
        /**
         * Gets this folder's sub folders
         *
         */
        get: function () {
            return new Folders(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Folder.prototype, "listItemAllFields", {
        /**
         * Gets this folder's list item field values
         *
         */
        get: function () {
            return new SharePointQueryableInstance(this, "listItemAllFields");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Folder.prototype, "parentFolder", {
        /**
         * Gets the parent folder, if available
         *
         */
        get: function () {
            return new Folder(this, "parentFolder");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Folder.prototype, "properties", {
        /**
         * Gets this folder's properties
         *
         */
        get: function () {
            return new SharePointQueryableInstance(this, "properties");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Folder.prototype, "serverRelativeUrl", {
        /**
         * Gets this folder's server relative url
         *
         */
        get: function () {
            return new SharePointQueryable(this, "serverRelativeUrl");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Folder.prototype, "uniqueContentTypeOrder", {
        /**
         * Gets a value that specifies the content type order.
         *
         */
        get: function () {
            return new SharePointQueryableCollection(this, "uniqueContentTypeOrder");
        },
        enumerable: true,
        configurable: true
    });
    /**
    * Delete this folder
    *
    * @param eTag Value used in the IF-Match header, by default "*"
    */
    Folder.prototype.delete = function (eTag) {
        if (eTag === void 0) { eTag = "*"; }
        return this.clone(Folder, null).postCore({
            headers: {
                "IF-Match": eTag,
                "X-HTTP-Method": "DELETE",
            },
        });
    };
    /**
     * Moves the folder to the Recycle Bin and returns the identifier of the new Recycle Bin item.
     */
    Folder.prototype.recycle = function () {
        return this.clone(Folder, "recycle").postCore();
    };
    /**
     * Gets the associated list item for this folder, loading the default properties
     */
    Folder.prototype.getItem = function () {
        var selects = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            selects[_i] = arguments[_i];
        }
        var q = this.listItemAllFields;
        return q.select.apply(q, selects).get().then(function (d) {
            return extend(new Item(odataUrlFrom(d)), d);
        });
    };
    /**
     * Moves a folder to destination path
     *
     * @param destUrl Absolute or relative URL of the destination path
     */
    Folder.prototype.moveTo = function (destUrl) {
        return this.select("ServerRelativeUrl").get().then(function (_a) {
            var srcUrl = _a.ServerRelativeUrl, absoluteUrl = _a["odata.id"];
            var webBaseUrl = extractWebUrl(absoluteUrl);
            var hostUrl = webBaseUrl.replace("://", "___").split("/")[0].replace("___", "://");
            var f = new Folder(webBaseUrl, "/_api/SP.MoveCopyUtil.MoveFolder()");
            return f.postCore({
                body: jsS({
                    destUrl: isUrlAbsolute(destUrl) ? destUrl : "" + hostUrl + destUrl,
                    srcUrl: "" + hostUrl + srcUrl,
                }),
            });
        });
    };
    /**
     * Copies a folder to destination path
     *
     * @param destUrl Absolute or relative URL of the destination path
     */
    Folder.prototype.copyTo = function (destUrl) {
        return this.select("ServerRelativeUrl").get().then(function (_a) {
            var srcUrl = _a.ServerRelativeUrl, absoluteUrl = _a["odata.id"];
            var webBaseUrl = extractWebUrl(absoluteUrl);
            var hostUrl = webBaseUrl.replace("://", "___").split("/")[0].replace("___", "://");
            var f = new Folder(webBaseUrl, "/_api/SP.MoveCopyUtil.CopyFolder()");
            return f.postCore({
                body: jsS({
                    destUrl: isUrlAbsolute(destUrl) ? destUrl : "" + hostUrl + destUrl,
                    srcUrl: "" + hostUrl + srcUrl,
                }),
            });
        });
    };
    return Folder;
}(SharePointQueryableShareableFolder));
export { Folder };
//# sourceMappingURL=folders.js.map